import './StatisticsContainer.css';
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import RouterLink from '../atoms/RouterLink';
export const StatisticsContainer = _ref => {
  let {
    fields,
    rendering,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA';
  const title = get(fields, 'data.item.title.jss');
  const readMoreLink = get(fields, 'data.item.readMoreLink.jss.value.href');
  const dictionary = get(fields, 'data.dictionary');
  const heading = get(fields, 'data.item.heading.jss.value');
  const description = get(fields, 'data.item.description');
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  if (!fields) {
    console.warn('StatisticsContainer component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [StatisticsContainer component is empty: please provide data source]");
    }
    return null;
  }

  // Those tweaks with length and  slice arguments are for three cases:
  //  - show  single wide element and not  extra markup
  //  - show two elements as half width blocks
  //  - show first element wide and all other as silder

  const renderPlaceholder = () => {
    if (!rendering) {
      console.error("The 'rendering' prop is required.");
      alert("The 'rendering' prop is required.");
      return /*#__PURE__*/React.createElement("div", null, "Error: 'rendering' prop is missing.");
    } else {
      return /*#__PURE__*/React.createElement(Placeholder, {
        name: "statistics-container",
        rendering: rendering
      });
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-md-center-x statistics-container__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 bgn__col statistics-container__title-btn-row justify-content-center"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "bgn__main-title",
    field: title,
    tag: "h2"
  }), heading && /*#__PURE__*/React.createElement("h3", {
    className: "h3 bgn__title"
  }, heading), description && /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "bgn__desc",
    field: description.jss
  })), process.env.STORYBOOK_MODE ? children : renderPlaceholder(), /*#__PURE__*/React.createElement("div", {
    className: `col-md-12 bgn__col statistics-container__title-btn-row justify-content-center`
  }, readMoreLink && /*#__PURE__*/React.createElement(RouterLink, {
    className: `statistics-container__cta bgn__link-last btn ${isDetSite ? 'btn-primary' : 'btn-secondary'}`,
    href: readMoreLink
  }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaLeftIcon
    },
    className: "ctaLeftIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
    className: "btn-secondary__text bgn__link-text"
  }, " ", getDictionaryItem(dictionary, 'readmore')), ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaRightIcon
    },
    className: "ctaRightIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "cdwgmva" : "crs6c15";
  const ltrStyles = "lckzftc";
  const rtlStyles = "rgmrszd";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default StatisticsContainer;